import ExpressRegisterPage from "./ExpressRegisterPage";

export default ExpressRegisterPage;

export * from "./ExpressRegisterPage";
